<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useResultsV2CardsStore } from "@stores/survey/resultsV2/resultsV2.cards";
import { AiHtmlInput } from "@/components/episto-ui/ai";
import StylePicker from "./StylePicker.vue";
import OptionRow from "./CardOptionFields/OptionRow.vue";
import OptionSection from "./CardOptionFields/OptionSection.vue";
import type { ResultsCard } from "@/types";

const props = defineProps({
  card: { type: Object as PropType<ResultsCard>, required: true },
});

const cardsStore = useResultsV2CardsStore();

const textContent = computed({
  get: () => String(props.card.content?.text || ""),
  set: (val: string) => {
    cardsStore.updateCardLocal(props.card.id, {
      content: { ...props.card.content, text: val },
    });
  },
});

const textStyle = computed({
  get: () => String(props.card.content?.style || "none"),
  set: (val: string) => {
    cardsStore.updateCardLocal(props.card.id, {
      content: { ...props.card.content, style: val },
    });
  },
});
</script>

<template>
  <OptionSection
    id="display"
    title="Display">
    <OptionRow
      label="Style"
      hint="Visual style of the block: note, tip, warning, quote or plain text.">
      <StylePicker v-model="textStyle" />
    </OptionRow>
    <OptionRow
      label="Text"
      hint="The text of the block, with basic formatting.">
      <AiHtmlInput
        :model-value="textContent"
        placeholder="Enter text..."
        @update:model-value="textContent = $event" />
    </OptionRow>
  </OptionSection>
</template>
